import React from "react";
import { bool, string } from "prop-types";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { useTranslation } from "@lib/i18n";

import FilterResultItemWrapper from "./FilterResultItemWrapper";

import { testDriveVehicleType } from "@types";
import { transformVehicleDataToTestDrivePoint } from "@lib/transformVehicleDataToTestDrivePoint";
import { ROUTES } from "@shared/routing/routes";
import { useRoutingUtils } from "@hooks/useRoutingUtils";

import { useTestDriveTypesSelector } from "@redux/reducers/appConfig";
import {
  setTestDrivePointAction,
  setTestDriveSlotAction,
} from "@redux/actions/testDriveActions";

const VehicleResultItem = ({ point, isActive, accentColor }) => {
  const { id, code, type, distanceInMeters } = point;

  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const router = useRouter();
  const routingUtils = useRoutingUtils();
  const testDriveTypes = useTestDriveTypesSelector();

  const testDriveType =
    testDriveTypes?.find(({ id }) => id.toLowerCase() === type.toLowerCase()) ??
    null;

  const handleItemPick = () => {
    dispatch(setTestDriveSlotAction(null));

    dispatch(
      setTestDrivePointAction(transformVehicleDataToTestDrivePoint(point))
    );
  };

  return (
    <FilterResultItemWrapper
      accentColor={accentColor}
      onPick={handleItemPick}
      onPickSuccess={() =>
        router.push(
          ROUTES.TEST_DRIVE_DETAIL_LOCATION,
          routingUtils.getLocalizedPathname(
            ROUTES.TEST_DRIVE_DETAIL_LOCATION,
            { locationSlug: encodeURIComponent(id) },
            i18n.language
          )
        )
      }
      distanceInMeters={distanceInMeters}
      isActive={isActive}
      testDriveType={testDriveType}
      name={t("testDrive.LocationType.vehicleResultItemLabel")}
    >
      <div>{t("testDrive.vehicleCode", { vehicleCode: code })}</div>
    </FilterResultItemWrapper>
  );
};

VehicleResultItem.propTypes = {
  point: testDriveVehicleType,
  isActive: bool.isRequired,
  accentColor: string.isRequired,
};

export default VehicleResultItem;
